import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDiary } from "@/context/DiaryContext";
import styles from "./styles";
import theme from "@/constants/theme";

export default function DailyFinish() {
  const navigate = useNavigate();

  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => setWindowHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { resetDiaryData } = useDiary();

  const handleBack = () => {
    navigate("/records/daily-tips");
  };

  const handleNext = () => {
    resetDiaryData();
    navigate("/");
  };

  return (
    <div style={styles.container}>
      <div
        style={{
          position: "relative",
          width: "100%",
          height: windowHeight * 0.55,
          overflow: "hidden",
        }}
      >
        <img
          src={require("@/assets/images/daily-finish.jpeg")}
          alt="Registro Diario"
          style={styles.img}
        />
        <div style={styles.linearGradient} />
      </div>

      <div style={styles.content}>
        <h1 style={styles.title}>¡Felicidades! Terminaste tu registro!</h1>
        <p style={styles.description}>
          Recuerda que registrar tu día de forma regular es una herramienta
          poderosa para generar conciencia sobre tus sentimientos. ¡Practica las
          técnicas recomendadas y continúa aprendiendo con las rutas
          personalizadas!
        </p>
      </div>

      <div style={styles.buttonsContainer}>
        <button style={styles.backButton} onClick={handleBack}>
          <span style={styles.backButtonText}>Atrás</span>
        </button>
        <button style={styles.nextButton} onClick={handleNext}>
          <span style={styles.nextButtonText}>Finalizar</span>
        </button>
      </div>
    </div>
  );
}
